'use client';

import React from 'react';
import Contact from '@/components/contact-us/Contact';

interface PageContentProps {
  locale: string;
}

export default function PageContent({ locale }: PageContentProps) {
  return <Contact locale={locale} />;
}
